import React from "react";
import { useTranslation } from "@helpers/translate";
import TradeArrowUpIcon from "@assets/icons/TradeArrowUpIcon";
import TradeArrowDownIcon from "@assets/icons/TradeArrowDownIcon";
import InfoCircleIcon from "@assets/icons/InfoCircleIcon";
import { LeverageInput } from "../LeverageInput/LeverageInput";
import { SHORT_COLOR } from "../../constants";
import { blurOnEnter } from "../../utils/input";

/**
 * @param {object} props
 */
export const WagerSection = ({
  isLong,
  directionColor,
  pairMeta,
  baseAsset,
  displayWager,
  wagerFieldWidth,
  onWagerInput,
  onWagerBlur,
  isWagerError,
  wagerErrorText,
  onHalf,
  onDouble,
  onMax,
  balanceText,
  leverageDraft,
  leverageInputRef,
  onLeverageInput,
  onLeverageFocus,
  onLeverageBlur,
  leverageFieldWidth,
}) => {
  const { __ } = useTranslation();
  const DirectionIcon = isLong ? TradeArrowUpIcon : TradeArrowDownIcon;

  return (
    <div className="trade-form__wager" data-futures-guide="position-size">
      <div className="trade-form__wager-head">
        <p className="trade-form__label">{__("futures.trade_form.wager_leverage")}</p>

        <div className="trade-form__icons">
          <DirectionIcon size={20} color={directionColor} />

          {pairMeta?.icon ? (
            <img
              src={pairMeta.icon}
              alt={baseAsset || "asset"}
              className="trade-form__coin"
            />
          ) : (
            <span className="trade-form__coin trade-form__coin--placeholder" />
          )}
        </div>
      </div>

      <div className="trade-form__wager-values">
        <div
          className={`trade-form__amount${isWagerError ? " trade-form__amount--error" : ""}`}
        >
          <span className="trade-form__sign">$</span>
          <input
            className="trade-form__field"
            value={displayWager}
            onChange={onWagerInput}
            onBlur={onWagerBlur}
            onFocus={(event) => event.target.select()}
            onKeyDown={blurOnEnter}
            style={{ width: wagerFieldWidth }}
            inputMode="decimal"
            aria-label={__("futures.mobile_trade.wager")}
            placeholder="0.00"
            autoComplete="off"
          />
        </div>

        <LeverageInput
          leverageDraft={leverageDraft}
          leverageInputRef={leverageInputRef}
          onLeverageInput={onLeverageInput}
          onLeverageFocus={onLeverageFocus}
          onLeverageBlur={onLeverageBlur}
          leverageFieldWidth={leverageFieldWidth}
        />
      </div>

      {isWagerError && (
        <p className="trade-form__wager-error" role="alert">
          <InfoCircleIcon size={14} color={SHORT_COLOR} />
          {wagerErrorText}
        </p>
      )}

      <div className="trade-form__wager-meta">
        <div
          className="trade-form__chips"
          data-futures-guide="position-size-percentages"
        >
          <button type="button" className="trade-form__chip" onClick={onHalf}>
            1/2
          </button>
          <button type="button" className="trade-form__chip" onClick={onDouble}>
            2x
          </button>
          <button type="button" className="trade-form__chip" onClick={onMax}>
            {__("futures.max")}
          </button>
        </div>

        <p className="trade-form__balance">
          <span className="trade-form__balance-label">{__("futures.available_balance")}:</span>
          <span className="trade-form__balance-value">{balanceText}</span>
        </p>
      </div>
    </div>
  );
};
